import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import {  delay } from "rxjs/operators";
import { BillingApiService } from "./billing-api.service";
import { fromAccount, State } from "../../store";
import { Store } from "@ngrx/store";
import { GetModalPayloadService } from "./getmodalpayload.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GoogleAnalyticsService } from "./google-analytics.service";
import { ConfirmOneIncHandoffModalComponent } from "../components/confirm-oneinc-handoff-modal/confirm-oneinc-handoff-modal.component";

declare const OneInc: any;
declare type CreateSessionResponse = {
  AccessTokenId: string;
  SessionId: string;
  ResponseMessage: string;
  ResponseCode: string;
};

@Injectable({
  providedIn: "root",
})
export class OneIncApiService {
  private listeningForOneIncEvents: boolean = false;
  private currentAccountNumber: string;

  constructor(
    private modalService: NgbModal,
    private billingApi: BillingApiService,
    private modalPayloadService: GetModalPayloadService,
    private store: Store<State>,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  initialize() {
    this.addOneIncScript();
  }

  openModal(operation: string, accountNumber: string) {
    if (operation === 'managePaymentMethods') {
      this.openOneIncModal(operation, accountNumber);
    } else {
       const modal = this.modalService.open(ConfirmOneIncHandoffModalComponent, {
          backdrop: "static",
          backdropClass: "moe-dark-grey-backdrop",
          modalDialogClass: "confirm-oneinc-handoff-modal",
          windowClass: "confirm-oneinc-handoff-modal",
        });
        modal.result.then((params) => {
          this.googleAnalyticsService.addButtonClick(params.continue ? 'Continue' : 'Cancel', '[OneInc]');
          if (params && params.continue) {
            this.openOneIncModal(operation, accountNumber);
          }
      });      
    }

   
  }


  openOneIncModal(operation: string, accountNumber: string) {
    this.currentAccountNumber = accountNumber;
    const container: HTMLElement = document.body;
    this.modalPayloadService.getModalPayload(operation, accountNumber).subscribe({
      next: (response) => {
        if (response?.accessTokenId && response?.sessionId) {
          const container = document.querySelector("#portalOneContainer");
          var portalOne: any = new OneInc.PortalOne(
            container,
            this.listeningForOneIncEvents
              ? null
              : this.subscribeToEvents.bind(this)
          );

          portalOne.run({
            sessionId: response.sessionId,
            accessTokenId: response.accessTokenId,
            displayMode: "Modal",
            allowClosing: "true",
          });

          this.listeningForOneIncEvents = true;
        } else {
          container.dispatchEvent(
            new CustomEvent("portalOne.error", {
              detail: {
                description: `The ${operation} portal loading failed: Can't create session key`,
              },
            })
          );
        }
      },
    });
  }

  private addOneIncScript() {
    let oneIncScriptElement: HTMLScriptElement =
      document.createElement("script");
    oneIncScriptElement.async = true;
    oneIncScriptElement.src = environment.portalOneModalV2Url;
    document.head.prepend(oneIncScriptElement);
  }

  private subscribeToEvents(container: HTMLElement) {
    var self = this;
    if (!container) {
      return;
    }
    container.addEventListener("portalOne.load", function () {
      console.info("load");
    });
    container.addEventListener("portalOne.unload", function () {
      console.info("unload");
      self.loadDueInfo(self.currentAccountNumber);
    });
    container.addEventListener("portalOne.error", function (e: CustomEvent) {
      console.error("error", e.detail);
    });
    container.addEventListener(
      "portalOne.paymentComplete",
      function (e: CustomEvent) {
      }
    );
    container.addEventListener("portalOne.paymentCanceled", function () {
      console.warn("paymentCanceled");
    });
    container.addEventListener(
      "portalOne.saveComplete",
      function (e: CustomEvent) {
        console.warn("saveComplete", e.detail);
      }
    );
    container.addEventListener("portalOne.saveCanceled", function () {
      console.warn("saveCanceled");
    });
  }

  private loadDueInfo(accountNumber: string) {
    this.billingApi.getBillingSummary(accountNumber).pipe(delay(1000)).subscribe({
      next: (p) => {
            this.store.dispatch(
              fromAccount.actions.updateDueInfo({
                accountNumber: accountNumber,
                balance: p.totalDue,
                dueDate: p.dueDate,
                minimumDue: p.minimumDue.toString(),
                autoPay: p.autopayType?.toLowerCase() !== 'no' ? p.autopayType : null,
                dueDay: p.dueDay?.toString(),
                transactions: p.transactions?.map((t) => {
                  return {
                    amount: t.amount?.toString(),
                    balance: t.balance?.toString(),
                    description: t.description,
                    effectiveDate: t.effectiveDate,
                    policyNumber: t.policyNumber,
                    premium: t.premium?.toString(),
                    transactionDate: t.transactionDate,
                  };
                }) ?? [],
              })
            );


      },
      error: (error) => {},
    });
  }
}
